export default __webpack_public_path__ + "static/media/monsterbar_mobile.429292e1.jpg";